import PropTypes from 'prop-types'
import React from 'react'

import SearchLink from '../../../../shared/containers/searchLinkContainer'
import RemoveIcon from '../../../../shared/components/icons/close'

import styles from './filterItem.module.css'

/**
 * A function to render the selected filter link
 * @param  {String} the type of the param, can be category, tags
 * @param  {String} the displayName of the filter
 * @param  {Object} the locationParams
 * @param  {Number} the index of the current option
 * @return {HTML} HTML for the option
 */
const FilterItem = ({ displayName, locationParams, index }) => {
  return (
    <li key={index}>
      <SearchLink locationParams={locationParams} className={styles.container}>
        <div className={styles.nameContainer}>
          <span className={styles.name}>{displayName}</span>
        </div>
        <span className={styles.removeLink}>
          <RemoveIcon width="8" height="8" className={styles.icon} />
        </span>
      </SearchLink>
    </li>
  )
}

FilterItem.propTypes = {
  displayName: PropTypes.string.isRequired,
  locationParams: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired
}

export default FilterItem
